import I18n from 'I18n';
import { ON_LAST_DAY, ON_NTH_WEEKDAY, NOT_APPLICABLE } from 'automation-ui-enrollment/constants/scheduledEnrollment/ExpressionTypes';
import { DayOfWeekValues } from 'automation-ui-enrollment/constants/scheduledEnrollment/DayOfWeekValues';
/* Represents a day of the month that can change depending on the current month or year */
export const DayOfMonthFlexValues = {
  ON_LAST_DAY: {
    id: 'ON_LAST_DAY',
    labelKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.flexDays.values.lastDay.label',
    descriptionKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.flexDays.values.lastDay.description',
    isSelected: schedule => schedule.dayOfMonth && schedule.dayOfMonth.expressionType === ON_LAST_DAY,
    scheduleUpdater: previousSchedule => previousSchedule.set('dayOfMonth', {
      expressionType: ON_LAST_DAY
    }).set('dayOfWeek', {
      expressionType: NOT_APPLICABLE
    })
  },
  FIRST_MONDAY: {
    id: 'FIRST_MONDAY',
    labelKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.flexDays.values.firstMonday.label',
    descriptionKey: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.flexDays.values.firstMonday.description',
    isSelected: schedule => schedule.dayOfWeek && schedule.dayOfWeek.expressionType === ON_NTH_WEEKDAY,
    scheduleUpdater: previousSchedule => previousSchedule.set('dayOfMonth', {
      expressionType: NOT_APPLICABLE
    }).set('dayOfWeek', {
      expressionType: ON_NTH_WEEKDAY,
      weekday: DayOfWeekValues.MONDAY,
      nvalue: 1
    })
  }
};

/* represents specific days of the month like 1, 2, 3 etc... */
export const DayOfMonthSpecificDayValues = Array.from(new Array(32).keys()).slice(1);

// 30 days hath september, april june and november..
export const getNumDaysForMonth = monthNum => {
  const paddedMonth = monthNum < 10 ? `0${monthNum}` : monthNum.toString();
  const daysInMonth = I18n.moment(`0000-${paddedMonth}`, 'YYYY-MM').daysInMonth();
  return DayOfMonthSpecificDayValues.slice(0, daysInMonth);
};